import { useEffect } from "react";

const SUFFIX = " - Volum";

function usePageTitle(title: string) {
    let counter = 0;

    useEffect(() => {
        document.title = counter > 0 ? `(${counter}) ${title}${SUFFIX}` : `${title}${SUFFIX}`;
    }, [title, counter]);
}

export default usePageTitle;
